import { render, staticRenderFns } from "./CompetenceList.vue?vue&type=template&id=2eef7a3d"
import script from "./CompetenceList.vue?vue&type=script&lang=ts"
export * from "./CompetenceList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports